import ViewDocsByTheme from '../implementations/View/DocsByTheme';
import ViewEventsUpcoming from '../implementations/View/EventsUpcoming';

const mappers = {
  views_block__docs_by_theme: ViewDocsByTheme,
  views_block__events_upcoming: ViewEventsUpcoming,
};

export default mappers;
